import React, { createContext, useContext, useState, ReactNode } from "react";

// Define the context type
interface JoinNowContextType {
  step: number;
  setStep: (step: number) => void;
  first_name: string;
  setFirstName: ( first_name: string) => void;
 last_name: string;
  setLastName: (last_name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  phone_no: string;
  setPhoneNumber: (phone_no: string) => void;
  identity: string;
  setCNICNumber: (identity: string) => void;
  dob: Date;
  setDob: (dob: Date) => void;
  gender: string;
  setGender: (gender: string) => void;
  referral: string;
  setReferral: (referral: string) => void;
  membershipId:number;
  setPlanId: (membershipId:number) => void;
  otp: string;
  setOtp: (otp: string) => void;
  emergencyPhone: string;
  setEmergencyPhoneNumber: (emergencyPhone: string) => void;
  emergencyName: string;
  setEmergencyName: (emergencyName: string) => void;
  selectContact: string;
  setSelectContactMethod: (selectContact: string) => void;
  selectedPlan:string;
  setSelectedPlan: (selectedPlan: string)=>void;
  month:number;
  setMonth: (month: number)=>void;

}

// Create the context with a default value
const JoinNowContext = createContext<JoinNowContextType | undefined>(undefined);

// Create a provider component
interface JoinNowProviderProps {
  children: ReactNode;
}

export const JoinNowProvider: React.FC<JoinNowProviderProps> = ({ children }) => {
  const [step, setStep] = useState<number>(0);
  const [ first_name, setFirstName] = useState<string>("");
  const [last_name, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone_no, setPhoneNumber] = useState<string>('');
  const [identity , setCNICNumber] =useState<string>('')
  const [dob, setDob] = useState<Date>(new Date());
  const [gender, setGender] = useState<string>('');
  const [referral, setReferral] = useState<string>('');
  const [membershipId, setPlanId] = useState<number>(0);
  const [otp,setOtp]=useState<string>("")
  const [emergencyPhone,setEmergencyPhoneNumber]=useState<string>("")
  const [emergencyName,setEmergencyName]=useState<string>("")
  const [selectContact, setSelectContactMethod] = useState<string>("")
  const [selectedPlan,setSelectedPlan]=useState(null);
  const [month,setMonth]=useState(null)

  return (
    <JoinNowContext.Provider
      value={{
        step,
        setStep,
        first_name,
        setFirstName,
       last_name,
        setLastName,
        email,
        setEmail,
        phone_no,
        setPhoneNumber,
        identity,
        setCNICNumber,
        dob,
        setDob,
        gender,
        setGender,
        referral,
        setReferral,
        membershipId,
        setPlanId,
        otp,
        setOtp,
        emergencyName,
        setEmergencyName,
        emergencyPhone,
        setEmergencyPhoneNumber,
        selectContact,
        setSelectContactMethod,
        selectedPlan,
        setSelectedPlan,
        month,
        setMonth,
      }}
    >
      {children}
    </JoinNowContext.Provider>
  );
};

// Create a custom hook to use the context
export const useJoinNowContext = (): JoinNowContextType => {
  const context = useContext(JoinNowContext);
  if (!context) {
    throw new Error("useJoinNowContext must be used within a JoinNowProvider");
  }
  return context;
};
